module.exports = __webpack_public_path__ + "img/home-clients-noise.png?7046e5c2d0c21603efb8d816947a3515";